import type { ReactNode } from 'react';

export const symbol_roofing: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M427-160q-24.75 0-42.37-17.63Q367-195.25 367-220v-106q0-24.75 17.63-42.38Q402.25-386 427-386h106q24.75 0 42.38 17.62Q593-350.75 593-326v106q0 24.75-17.62 42.37Q557.75-160 533-160H427Zm0-60h106v-106H427v106ZM100-474q-10.35 8-22.17 6Q66-470 58-480q-8-10-6.06-22.19Q53.89-514.38 64-522l380-291q7.94-6 16.97-9 9.03-3 19.03-3 10 0 19.03 3 9.03 3 16.97 9l142 108v-45q0-20.83 14.62-35.42Q687.24-800 708.12-800q20.88 0 35.38 14.58Q758-770.83 758-750v122l139 106q9.94 7.62 11.47 19.81Q910-490 902-480q-8 10-19.83 12-11.82 2-22.17-6L480-765 100-474Zm380 201Z"
		/>
	</svg>
);
